import { useState } from "react";
import s from "./PhotoGallery.module.scss";
import { CLOUDINARY_BASE_URL } from "../../config/cloudinary";
import { useLanguage } from "../../contexts/LanguageContext";
import { INSTAGRAM_URL } from "../../config/socialLinks";
import { trackCtaClick } from "../../utils/analytics";
import ImageLightbox, { ImageZoomButton } from "../ImageLightbox/ImageLightbox";

const img = (path) => `${CLOUDINARY_BASE_URL}${path}`;

const photos = [
  img("v1784266422/DSC00400-2_ddg5if.jpg"),
  img("v1784266410/DJI_20260714133703_0069_D_cp1tbk.webp"),
  img("v1784191325/image9_vwojco.webp"),
  img("v1784944008/DJI_20260724142728_0046_D_fjvofb.webp"),
  img("v1784945639/DSC00440-2_syxyio.webp"),
  img("v1784190105/DSC00269_hmidsf.jpg"),
  img("v1784189987/image4_gbt8eh.webp"),
  img("v1784466423/DJI_20260718160638_0015_D_gh8w0n.webp"),
  img("v1783932710/GP010138_penbxd.webp"),
  img("v1784766584/DJI_20260722151517_0012_D_mxjroa.webp"),
  img("v1784767636/IMG_5428_oepvhn.jpg"),
  img("v1785005393/DSC00191_small_lhfvnk.jpg"),
  img("v1784766585/DJI_20260722154007_0060_D_azbuxt.webp"),
  img("v1783928240/DJI_20260707115904_0007_D_cui3oa.webp"),
  img("v1741535462/20250307215516_b70rgq.webp"),
  img("v1785005393/DJI_20260722152001_0021_D_small_odgfk0.jpg"),
  img("v1784767309/IMG_5481_ie849d.jpg"),
  img("v1784266419/DSC00402-2_yvxp8t.jpg"),
  img("v1785007375/DJI_20260707133512_0066_D_small_texksj.jpg"),
];

const TEXT = {
  JP: {
    kicker: "Photo Gallery",
    title: "Beautiful Memories",
    description:
      "宮古島で過ごした特別な時間。ドローン撮影やSUPツアー、サンセットの思い出をご紹介します。",
    follow: "Instagramを見る",
    alt: "宮古島フォトギャラリー",
  },
  EN: {
    kicker: "Photo Gallery",
    title: "Beautiful Memories",
    description:
      "A collection of special moments in Miyako Island, from drone shots and SUP tours to unforgettable sunsets.",
    follow: "Follow on Instagram",
    alt: "Miyakoisland photo gallery",
  },
  中文: {
    kicker: "照片集",
    title: "美好的回忆",
    description:
      "这里展示在宫古岛度过的特别时光，包括无人机拍摄、SUP体验和日落回忆。",
    follow: "关注 Instagram",
    alt: "宫古岛照片集",
  },
  한국어: {
    kicker: "포토 갤러리",
    title: "아름다운 추억",
    description:
      "미야코지마에서 보낸 특별한 시간, 드론 촬영과 SUP 투어, 선셋의 추억을 소개합니다.",
    follow: "Instagram 보기",
    alt: "미야코지마 포토 갤러리",
  },
};

const PhotoGallery = () => {
  const { lang } = useLanguage();
  const t = TEXT[lang] || TEXT.JP;
  const [enlargedImage, setEnlargedImage] = useState(null);

  return (
    <section className={s.root}>
      <div className={s.galleryLayout}>
        <div className={s.content}>
          <span className={s.kicker}>{t.kicker}</span>
          <h2>{t.title}</h2>
          <p>{t.description}</p>
        </div>

        <div className={s.grid}>
          {photos.map((photo, index) => (
            <div key={index} className={s.item}>
              <img src={photo} alt={`${t.alt} ${index + 1}`} />
              <ImageZoomButton
                onClick={() => setEnlargedImage(photo)}
                ariaLabel={`${t.alt} ${index + 1}を大きく見る`}
              />
            </div>
          ))}
        </div>
      </div>

      <div className={s.followWrapper}>
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noreferrer"
          className={s.followButton}
          onClick={() =>
            trackCtaClick({
              label: "instagram_gallery_follow",
              placement: "photo_gallery",
              destination: INSTAGRAM_URL,
              destinationType: "external_social",
            })
          }
        >
          {t.follow}
        </a>
      </div>

      <ImageLightbox
        image={enlargedImage}
        alt={t.alt}
        onClose={() => setEnlargedImage(null)}
      />
    </section>
  );
};

export default PhotoGallery;
